<div class="container">
  <ng-container *ngIf="!loadingTransaction">
    <mat-table [dataSource]="transactions" class="content">
      <ng-container matColumnDef="code">
        <mat-header-cell *matHeaderCellDef>{{ transactionExpandedLabels.code }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="flex-cell">
          <span *ngFor="let item of element.points">{{ item.pointCode }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="serial">
        <mat-header-cell *matHeaderCellDef>{{ transactionExpandedLabels.printerSerial }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="flex-cell">
          <span *ngFor="let item of element.points">{{ item.equipmentSerial }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="points">
        <mat-header-cell class="points-column" *matHeaderCellDef>{{ transactionExpandedLabels.points }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="flex-cell points-column">
          <span *ngFor="let item of element.points">{{ item.quantity  | number:'': language }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="addedby">
        <mat-header-cell *matHeaderCellDef>{{ transactionExpandedLabels.labelBy }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="user-data"
            [matTooltip]="(element.userName.length > 20) ? element.userName : ''" 
            matTooltipClass="name-tooltip" *ngIf="element.transactionType !== transactionTypes.PORT">{{ element.userName }} </span> 
          <ng-container *ngIf="element.transactionType === transactionTypes.PORT">{{ transactionExpandedLabels.portPrinters }} </ng-container>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="expiresOn">
        <mat-header-cell *matHeaderCellDef>{{ transactionExpandedLabels.expiresOn }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span >{{element.expirationDate | date: dateFormat : 'UTC' : language}}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="note">
        <mat-header-cell *matHeaderCellDef>{{ transactionExpandedLabels.notes }}</mat-header-cell>
        
        <mat-cell *matCellDef="let element" class="note-cell">
          <app-icon-click id="notes-info-popup" flat (click)="toggleNotes(element)" *ngIf="element.note?.trim()">comment</app-icon-click>
          
          <div class="popup-preamble" *ngIf="activeElement === element && showNotes">
            <app-notes-info-popup (closeClick)="closeNotes()"
            [ngClass]="{'visible': showNotes}" 
            [note]="note"
            [canSave]="false">
            </app-notes-info-popup>
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </ng-container>

  <mat-spinner
    *ngIf="loadingTransaction"
    class="loading"
    diameter="50"
  ></mat-spinner>
</div>
